import Image from "next/image";
import Link from "next/link";
import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer/Footer";
// import IFSform from "./ifs-interview-form";
import styles from "../upsc-interview/upsc-interview.module.css";
//import WebBanner from "../../assets/images/upsc/Scholarship-Web-Banner.webp";
import Head from "next/head";

const ifsInterview2023 = () =>{

    const prelimlist =[
        {list:"Consistently producing toppers since 2004"},
        {list:"Experienced Faculty Team (10+ Years)  "},
        {list:"Regular Guidance From Achievers"},
        {list:"Scheduled interaction with bureaucrats (serving and retired)"},
        {list:"Personalised and scientific mentoring"},

      ]

   

    return(
        <>
            <Head>
                
                <meta charset="UTF-8" />
                
                <meta name="viewport" content="width=device-width, initial-scale=1" />
                <meta name="robots" content="noodp,noydir" />
                <meta name="robots" content="noindex,nofollow" />
                <meta name="robots" content="noindex,nofollow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
                <meta property="article:publisher" content="https://www.facebook.com/shankariasacademy" />
                <meta property="article:modified_time" content="2024-01-25T05:43:44+00:00" />
                <title>UPSC Scholarship Test 2024 | Shankar IAS Academy</title>
                <meta name="title" content="UPSC Scholarship Test 2024  | Shankar IAS Academy" />
                <meta name="description" content="Join our UPSC Scholarship Test. Earn scholarships for UPSC coaching fees, removing financial barriers on your path to Civil Services excellence." />
                <link rel="canonical" href="https://www.shankariasacademy.com/upsc-scholarship-test/" />
                <meta property="og:locale" content="en_US" />
                <meta property="og:type" content="website" />
                <meta property="og:title" content="UPSC Scholarship Test 2024 | Shankar IAS Academy" />
                <meta property="og:description" content="Join our UPSC Scholarship Test. Earn scholarships for UPSC coaching fees, removing financial barriers on your path to Civil Services excellence." />
                <meta property="og:url" content="https://www.shankariasacademy.com/ifs-interview/" />
                <meta property="og:site_name" content="Shankar IAS Academy" />
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:site" content="@shankarias" />
              </Head>        
              <Navbar title="IFS-Interview-2023" />

        <div className="container">

        <div className="row">
        <div className="col pt-3 pt-md-4">
            <h1 className={`${styles.pagemaintitle}`}> UPSC Scholarship Test 2024</h1>
        </div>
        </div>

        <div className={`${styles.bgbox} row`}>
          {/*  <div className="col p-2">
                        <Image
                        src={WebBanner}
                        className="img-fluid w-100"
                        alt="IFS interview Banner"
                        title="UPSC IFS(Forestry) Interview Guidance Programme 2023"
                        />
            </div> */}
            <div className="d-flex justify-content-center py-3 py-md-5">
                <Link href="https://docs.google.com/forms/d/e/1FAIpQLSfpFQjhuMqkiHkEimXEc4RfsVQIvZmucF0u0dvhvGw7xTucjw/viewform?pli=1" target="_blank" className={`${styles.btnbox}`}>
                <p className="pt-3">UPSC Scholarship<br/> Registration 2024</p>
                <button className={`${styles.normalbutton} mb-3`}>Click Here</button>
                </Link>
            </div>
        </div>

        </div>
        
       

        <div className="container pt-3 pt-md-4">

            <div className="row">
                <div className="col">
                    <h2 className={`${styles.contactheader}`}>SHANKAR IAS ACADEMY EDGE!</h2>
                </div>
            </div>

            <div className="row">
                <div className="col-12 col-md-6 col-lg-4 col-xl-3 text-center pt-md-3 pt-lg-0">
                    <div className="p-4 h-100 py-5" style={{background: '#FFF3D3 0% 0% no-repeat padding-box', opacity: '1'}}>
                        <p className={`${styles.acheivername1} mb-0`}>Extensive coaching with more than 600 hours of classroom teaching</p>
                    </div>
                </div>
                <div className="col-12 col-md-6 col-lg-4 col-xl-3 text-center pt-3 pt-lg-0">
                    <div className="p-4 h-100 py-5" style={{background: '#FFF3D3 0% 0% no-repeat padding-box', opacity: '1'}}>
                        <p className={`${styles.acheivername1} mb-0`}>100+ hours of individual mentoring by experts</p>
                    </div>
                </div>
                <div className="col-12 col-md-6 col-lg-4 col-xl-3 text-center pt-3 pt-lg-0">
                    <div className="p-4 h-100 py-5" style={{background: '#FFF3D3 0% 0% no-repeat padding-box', opacity: '1'}}>
                        <p className={`${styles.acheivername1} mb-0`}>Extensive test series for prelims and mains</p>
                    </div>
                </div>
                <div className="col-12 col-md-6 col-lg-4 col-xl-3 text-center pt-3 pt-lg-3 pt-xl-0">
                    <div className="p-4 h-100 py-5" style={{background: '#FFF3D3 0% 0% no-repeat padding-box', opacity: '1'}}>
                        <p className={`${styles.acheivername1} mb-0`}>Comprehensive interview guidance program<br/>Comprehensive study and reference materials</p>
                    </div>
                </div>
            </div>

            <div className="row pt-4 pt-md-5">
                <div className="col">
                    <p className={`${styles.sectionsubtitle} mb-0`}>Key Differentiators</p>

                        <ul className={`${styles.ulclass} ps-1 pt-2`}>
                            {prelimlist.map((item,index)=>(
                                  <li
                                    className={`${styles.ulliclass} ${styles.acheiverrank}`}
                                    id={styles.acheiverrankspecial} key={index}
                                  >
                                    <div className="d-inline">
                                      <p className={`${styles.ullispan} d-inline`}>
                                        {item.list}
                                      </p>
                                    </div>
                                  </li>
                              ))}
                        </ul>
                </div>
            </div>

        </div>

        <Footer />
        </>
    )
}
export default ifsInterview2023